import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { SynchronisationIcon } from "../Icons/SynchronisationIcon";

@observer
export class SyncButton extends Button {

	render() {
		return <Button {...this.props} >
			<SynchronisationIcon />
		</Button>;
	}
}
